function findMatchingBrace(source: string, openBraceIndex: number): number {
  let depth = 0
  for (let i = openBraceIndex; i < source.length; i += 1) {
    const ch = source[i]
    if (ch === '{') depth += 1
    else if (ch === '}') {
      depth -= 1
      if (depth === 0) return i
    }
  }
  return -1
}

function extractEventInArrayLiteral(script: string): string | null {
  const marker = /eventRestrictions\.eventIn\s*\(\s*/.exec(script)
  if (!marker || marker.index == null) return null
  const start = marker.index + marker[0].length
  if (script[start] !== '[') return null
  let depth = 0
  let inString: '"' | "'" | null = null
  let escaped = false
  for (let i = start; i < script.length; i += 1) {
    const ch = script[i]
    if (inString) {
      if (escaped) {
        escaped = false
        continue
      }
      if (ch === '\\') {
        escaped = true
        continue
      }
      if (ch === inString) inString = null
      continue
    }
    if (ch === '"' || ch === "'") {
      inString = ch
      continue
    }
    if (ch === '[') depth += 1
    else if (ch === ']') {
      depth -= 1
      if (depth === 0) return script.slice(start, i + 1)
    }
  }
  return null
}

function extractListenersAddCallback(script: string): { params: string; body: string } | null {
  const addMatch = /listeners\.add\s*\(/.exec(script)
  if (!addMatch || addMatch.index == null) return null
  const fromAdd = script.slice(addMatch.index)
  const cbMatch = /,\s*(?:listener|function)\s*\(([^)]*)\)\s*\{/.exec(fromAdd)
  if (!cbMatch || cbMatch.index == null) return null
  const openBrace = addMatch.index + cbMatch.index + cbMatch[0].length - 1
  const closeBrace = findMatchingBrace(script, openBrace)
  if (closeBrace < 0) return null
  return {
    params: cbMatch[1].trim() || 'en',
    body: script.slice(openBrace + 1, closeBrace),
  }
}

function needsRawClientRewrite(script: string): boolean {
  if (/listeners\.add\s*\(\s*['"]serverEvent:/i.test(script)) return false
  // Server-only import evaluated at registration (e.g. getAllServiseTypes).
  if (/\$\s*\(\s*['"][^'"]+['"]\s*\)/.test(script)) return true
  // Raw Swing form: listeners.add(user, eventRestrictions.and([...]), listener…)
  if (
    /listeners\.add\s*\(\s*user\b/.test(script) &&
    /eventRestrictions\.and\s*\(/.test(script) &&
    /eventRestrictions\.eventIn\s*\(/.test(script)
  ) {
    return true
  }
  return false
}

/**
 * Normalize onServerEvent script for client registration.
 */
export function normalizeOnServerEventClientScript(script: string): string {
  if (!script || typeof script !== 'string') return script
  const trimmed = script.trim()
  if (!trimmed) return script
  if (!needsRawClientRewrite(trimmed)) return script

  const eventInLiteral = extractEventInArrayLiteral(trimmed)
  const callback = extractListenersAddCallback(trimmed)
  if (!eventInLiteral || !callback) return script

  return (
    `listeners.add(eventRestrictions.eventIn(${eventInLiteral}), function (${callback.params}) {` +
    `${callback.body}` +
    `});`
  )
}
